import api from "../api";
import qs from "qs";

export const atendimentoService = {
  async list(params) {
    return api.get(`/atendimentos/paginadas`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  async createAtendimentoPublica(atendimento) {
    return await api.post("/publico/atendimentos", atendimento);
  },

  async imprimirDenunciaPublica(codigoAtendimento) {
    return await api.get(
      `/publico/atendimentos/${codigoAtendimento}/imprimir`,
      {
        responseType: "blob",
      }
    );
  },

  denunciante: {
    async listar(codigoAtendimento) {
      return await api.get(`/atendimentos/${codigoAtendimento}/notificantes`);
    },

    async imprimir(codigoDenuncia) {
      return await api.get(`/atendimentos/${codigoDenuncia}/imprimir`, {
        responseType: "blob",
      });
    },

    async inserir(codigoDenuncia, codigoPessoa) {
      return await api.put(
        `/atendimentos/${codigoDenuncia}/notificantes/${codigoPessoa}`
      );
    },

    async remover(codigoDenuncia, codigoPessoa) {
      return await api.delete(
        `/atendimentos/${codigoDenuncia}/notificantes/${codigoPessoa}`
      );
    },
  },

  vitima: {
    async listar(codigoDenuncia) {
      return await api.get(`/atendimentos/${codigoDenuncia}/vitimas`);
    },

    async inserir(codigoDenuncia, codigoPessoa) {
      return await api.put(
        `/atendimentos/${codigoDenuncia}/vitimas/${codigoPessoa}`
      );
    },

    async remover(codigoDenuncia, codigoPessoa) {
      return await api.delete(
        `/atendimentos/${codigoDenuncia}/vitimas/${codigoPessoa}`
      );
    },
  },

  suspeito: {
    async listar(codigoDenuncia) {
      return await api.get(`/atendimentos/${codigoDenuncia}/infratores`);
    },

    async inserir(codigoDenuncia, codigoPessoa) {
      return await api.put(
        `/atendimentos/${codigoDenuncia}/infratores/${codigoPessoa}`
      );
    },

    async remover(codigoDenuncia, codigoPessoa) {
      return await api.delete(
        `/atendimentos/${codigoDenuncia}/infratores/${codigoPessoa}`
      );
    },
  },
};
